import { Col, Form, Row } from "react-bootstrap";
import { Calendar } from "primereact/calendar";
import { AutoComplete } from "primereact/autocomplete";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";
import ControlledInput from "../../common/ControlledInput";
import { CharacterLimit } from "../../common/CharacterLimit/CharacterLimit";
import { textFieldMaxLength } from "../../../constants";
import CalendarIcon from "../../common/CalendarIcon/CalendarIcon";
import UploadBriefingDocuments from "../DesignJobs/UploadBriefingDocuments";
import { alphanumericPattern } from "../../../constants/regex";

export default function TaskSpecificInfo({
  checkReadWriteAccess,
  setInputValid,
  pageEdited,
  setPageEdited,
  taskDetail,
  setDone,
  taskStatus,
  addNewFiles,
  onFileUpload,
  onFileClear,
  onNoteChange,
}) {
  const AzureSubFolder = "Custom Fullkit";

  const handleNoteChange = (e) => {
    if (!alphanumericPattern.test(e.target.value)) {
      onNoteChange(e);
    }
  };

  return (
    <div className="mb-4">
      <div className="fullkit-task-header">
        <span>{`${taskDetail?.type}_FK_${taskDetail?.value}`}</span>
        <span>
          <button
            className="add-file"
            onClick={() => addNewFiles()}
            disabled={
              taskStatus === "Complete" || taskStatus === "Cancelled" || !checkReadWriteAccess
            }
          >
            <i className="pi pi-plus plus-icon " /> Add files
          </button>
        </span>
      </div>
      <Row className="fullkit-task-details">
        <Col md={2}>
          <Form.Group>
            <Form.Label>Type</Form.Label>
            <AutoComplete id="type" value={taskDetail?.type} dropdown disabled />
          </Form.Group>
        </Col>
        <Col>
          <div className="d-flex flex-column">
            <label htmlFor="value">Value</label>
            <ControlledInput
              id="value"
              setInputValid={setInputValid}
              value={taskDetail?.value}
              maxLength={textFieldMaxLength}
              disabled={true}
            />
          </div>
          {(taskDetail?.value === "" || taskDetail?.value === undefined) && (
            <span className="error-text-di">Field Remaining</span>
          )}{" "}
          <CharacterLimit field={taskDetail?.value} maxLength={textFieldMaxLength} />
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Due Date</Form.Label>
            <Calendar
              id="due-date"
              minDate={new Date()}
              dateFormat="d-M-y"
              value={taskDetail?.date}
              icon={<CalendarIcon />}
              showIcon={true}
              disabled
            />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group>
            <Form.Label>Assignee</Form.Label>
            <AutoComplete id="assignee" value={taskDetail?.assignee} dropdown disabled />
          </Form.Group>
        </Col>
        <Col md={1}>
          <Form.Group>
            <Form.Label>Done</Form.Label>
            <p>
              <Checkbox
                onChange={() => setDone()}
                checked={taskDetail?.checked}
                disabled={
                  taskStatus === "Complete" || taskStatus === "Cancelled" || !checkReadWriteAccess
                }
              ></Checkbox>
            </p>
          </Form.Group>
        </Col>
      </Row>
      <Row className="mx-3">
        {taskDetail?.fileRequired &&
          checkReadWriteAccess &&
          taskStatus !== "Complete" &&
          taskStatus !== "Cancelled" && (
            <p className="mandatory-file-msg">
              A file upload is required to proceed with this task.
            </p>
          )}
        <Col>
          {taskDetail?.file.map((file, index) => (
            <UploadBriefingDocuments
              azureSubFolder={AzureSubFolder}
              key={index}
              item={file}
              pageEdited={pageEdited}
              setPageEdited={setPageEdited}
              checkReadWriteAccess={checkReadWriteAccess}
              fileUploadSection={`${taskDetail?.type}_FK_${taskDetail?.value}`}
              disableDelete={
                taskStatus === "Complete" ||
                taskStatus === "Cancelled" ||
                taskDetail?.file?.length === 1 ||
                !checkReadWriteAccess
              }
              taskStatus={taskStatus}
              onFileUpload={onFileUpload}
              onFileClear={onFileClear}
              sequence={file.Sequence}
            />
          ))}
        </Col>
      </Row>
      <Row className="mx-4">
        <div className="d-flex flex-column">
          <label htmlFor="note">Note</label>
        </div>
        <InputTextarea
          value={taskDetail?.note}
          onChange={(e) => handleNoteChange(e)}
          rows={5}
          cols={30}
          maxLength={512}
          disabled={
            taskStatus === "Complete" || taskStatus === "Cancelled" || !checkReadWriteAccess
          }
        />
      </Row>
    </div>
  );
}
